<div>
  <app-components-togglepanel [(isOpen)]="isOpen" title="Local Profiles" toggleBody="true">
    <app-components-shared-local-profile-initialization [customer]="customerJs">
    </app-components-shared-local-profile-initialization>
  </app-components-togglepanel>
</div>
